<template>
   <div class="menu-list batt-swap-page">
       <bs-card-menu class="mb12" v-for="item in menuList" :key="item.id" :options='item' @click="menuDetail(item)"></bs-card-menu>
   </div>
</template>

<script>
import utils from '@/utils/index.js'
import entrance from '@/mixin/entrance'
export default {
   data () {
      return {
         menuList:[],
         cycles:[],
      };
   },
   mixins:[entrance],
   mounted() {
      // 换电套餐
      document.title = this.$t('bstext.bs1') 
      this.cycles=this.$t('bsstatus.cycles')   
   },
   watch:{
      // 监听拿到token再调取接口
      token:function(newToken,oldToken){
         if(newToken){
            this.getServiceList()
         }
      }
   },
   methods: {
      getServiceList(){
         this.$appApi.nativeLoading(true,'',0)
         const req={
            page:1,
            pageSize:10000,
            excludeSid:-1,//全部套餐列表
         }
         this.$server.getServiceList(req).then(res=>{
            let list = res.data.list
            list.forEach((item,index)=> {
               item.price=utils.formatPrice(item.price)
               item.theme=index%2===0?'yellow':'blue'
               item.cycle=utils.formatStatus(item.cycle,this.cycles)
            });
            this.menuList=list
         }).finally(()=>{
            this.$appApi.nativeLoading(false,'',0)
         })
      },
      menuDetail(item){
         this.$router.push('/bs/battswap/menudetail/'+item.id)
      }
   }
}
</script>

<style lang='less' scoped>
.menu-list{
   .mb12{
      margin-bottom: 12px;
   }
}
</style>



// WEBPACK FOOTER //
// src/components/blueshark/battswap/menu/menulist.vue